// extracted by mini-css-extract-plugin
module.exports = {"root":"ColumnAccessor_root__vl5iS","cell":"ColumnAccessor_cell__3l-nB","firstCellAccent":"ColumnAccessor_firstCellAccent__2lLxt"};